import React from 'react';
import { Container, Row, Col, Button, Badge } from 'react-bootstrap';

interface HeroSectionProps {
  onBookingClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onBookingClick }) => {
  return (
    <section id="home" className="bg-gradient-hero text-white py-5 position-relative overflow-hidden">
      {/* Background Pattern */}
      <div className="position-absolute top-0 end-0 opacity-10" style={{fontSize: '20rem', lineHeight: '1', color: 'rgba(251,176,21,0.1)'}}>
        🔧
      </div>
      
      <Container className="position-relative">
        <Row className="align-items-center" style={{ minHeight: '80vh' }}>
          <Col lg={6}>
            <div className="mb-3">
              <Badge bg="yellow" text="dark" className="px-3 py-2 fs-6 me-2">
                ⭐ Since 2012
              </Badge>
              <Badge bg="outline-warning" className="px-3 py-2 fs-6">
                🏆 12+ Years Experience
              </Badge>
            </div>
            
            <h1 className="display-3 fw-bold mb-4 lh-1">
              Your Car's <span className="text-yellow">Best Friend</span><br/>
              <span className="fs-2">Expert Auto Care in Indore</span>
            </h1>
            
            <p className="lead mb-4 fs-5">
              From denting & painting to complete mechanical repairs - we've got your vehicle covered. 
              Professional service with honest pricing and guaranteed quality.
            </p>
            
            {/* Key Features */}
            <Row className="mb-4">
              <Col md={6}>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">✅</span>
                  <span>Expert Technicians</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">⚡</span>
                  <span>Same Day Service</span>
                </div>
              </Col>
              <Col md={6}>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">💰</span>
                  <span>Transparent Pricing</span>
                </div>
                <div className="d-flex align-items-center mb-2">
                  <span className="text-yellow fs-4 me-2">🛡️</span>
                  <span>Quality Guarantee</span>
                </div>
              </Col>
            </Row>
            
            <div className="d-flex flex-wrap gap-3">
              <Button 
                variant="warning" 
                size="lg" 
                onClick={onBookingClick}
                className="fw-bold px-4 py-3 text-dark"
              >
                📞 Book Service Now
              </Button>
              <Button 
                variant="outline-light" 
                size="lg" 
                href="#services"
                className="fw-bold px-4 py-3"
              >
                🔍 View Services
              </Button>
            </div>
            
            {/* Emergency Contact */}
            <div className="mt-4 p-3 bg-red rounded-3">
              <div className="d-flex align-items-center">
                <span className="fs-4 me-2">🚨</span>
                <div>
                  <strong>24/7 Emergency Service</strong><br/>
                  <span className="fs-5">📞 097552 65555</span>
                </div>
              </div>
            </div>
          </Col>
          
          <Col lg={6}>
            <div className="text-center">
              <img 
                src="/banner_1.png" 
                alt="Laxmi Tyres & Motors - Professional Car Service" 
                className="img-fluid rounded-4 shadow-lg"
                style={{maxHeight: '500px', width: '100%', objectFit: 'cover'}}
                onError={(e) => {
                  (e.target as HTMLImageElement).src = 'https://via.placeholder.com/600x400/064DA1/FFFFFF?text=Laxmi+Tyres+%26+Motors';
                }}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;